import React from "react";
import { AiFillLinkedin } from "react-icons/ai";
import { BsGithub } from "react-icons/bs";
import { SiHackerrank } from "react-icons/si";

const HeaderSocial = () => {
  return (
    <div className="header__socials">
      
    </div>
  );
};

export default HeaderSocial;
